module.exports = __webpack_public_path__ + "img/complete.e48c5ef2.png";